import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Grid } from '@material-ui/core';


const ColorCircularProgress = withStyles((theme) => ({
    root: {
        color: theme.palette.background.secondary,
        marginBottom: theme.spacing(2),
    },
}))(CircularProgress);

const ColorCircularProgressLight = withStyles((theme) => ({
    root: {
        color: theme.palette.background.primary,
        marginBottom: theme.spacing(2),
    },
}))(CircularProgress);

export default function CustomizedCircularProgress() {
    return ( 
        <Grid xs={12} item container justify='center'>
            <ColorCircularProgress size={20} thickness={5} />
        </Grid>
    );
}

export function CustomizedCircularProgressLight() {
    return ( 
        <Grid xs={12} item container justify='center'>
            <ColorCircularProgressLight size={20} thickness={5} />
        </Grid>
    );
}